// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dbc-dygraphs-dth{width:100%;height:100%}.dbc-dygraphs-dth .dygraph-legend2{font-size:14px;text-align:left;margin-left:65px}.dbc-dygraphs-dth .dygraph-title2{font-size:18px;text-align:center}", ""]);
// Exports
module.exports = exports;
